import axios, { AxiosInstance, AxiosResponse } from "axios";

import {
  DashboardFromRoleResponse,
  LoginResponse,
} from "../../@Types/DRO/ChurnApiResponse/LoginResponse";

import {
  ClientIdResponse,
  RejectResponse,
  HelpTicketResponse,
  ApprovedResponse,
  MerchantListResponse,
  KycTicketResponse,
  KycDocumentResponse,
  RejectKycResponse,
  ApproveData,
  TlDetailsResponse,
  TlDataResponse,
  RejectTlResponse
} from "../../@Types/DRO/Kyc/KycResponse";
export class AuthenticationApi {
  public static api = new AuthenticationApi();
  private instance: AxiosInstance;

 constructor() {
  this.instance = axios.create({
    baseURL: process.env.REACT_APP_MOBYCY_BASE_URL_PREPROD,
    headers: {
      "Content-Type": "application/json",
    },
  });

  // ✅ Add global response interceptor
  // this.instance.interceptors.response.use(
  //   (response) => response,
  //   (error) => {
  //     if (
  //       error.response?.data?.code === 1002 ||
  //       error.response?.data?.message === "Access denied!" ||
  //       error.response?.data?.message === "Session has expired or user is unauthorized"
  //     ) {
  //       localStorage.clear();
  //       sessionStorage.clear();
  //       window.location.href = "/";
  //     }
  //     return Promise.reject(error);
  //   }
  // );
}

  

  getToken() {
    return localStorage.getItem("token");
  }

  async onlineUserAuthentication(
    userName: string,
    password: string
  ): Promise<LoginResponse> {
    try {
      const response: AxiosResponse<LoginResponse> = await this.instance.get(
        `/auth/dash/login`,
        {
          params: {
            userName,
            password,
          },
        }
      );
      if (response.data && response.data.code === 2000) {
        localStorage.setItem("token", response.data.data.token);
      }
      return response.data;
    } catch (error) {
      throw new Error("Login failed");
    }
  }
  async getDashboardFromRole(role:string): Promise<DashboardFromRoleResponse> {
    try {
      const response: AxiosResponse<DashboardFromRoleResponse> =
        await this.instance.get("/kyc/api/role/dashboards", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            role
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions latest data", error);
      throw error;
    }
  }
  async ClientIdVerification(
   page:number,
   pageSize:number,
   searchValue:string,
   statusType:string,
   selectedMerchant:string | null,
  ): Promise<ClientIdResponse> {
    
    let apiUrl = "/integration/api/v1/get/all/client/requests";
    if (searchValue) {
      apiUrl += `?mobileNo=${searchValue}`;
    }
    try {
      const response: AxiosResponse<ClientIdResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            page:page,
            pageSize:pageSize,
            status:statusType,
            merchantId:selectedMerchant        
    
        },
          
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async rejectClientRequest(
    id: number,
    remarks: string
  ): Promise<RejectResponse> {
    let apiUrl = "/integration/api/v1/reject/client/request";
  
    // Build query string with remarks first
    if (remarks && id) {
      apiUrl += `?remarks=${remarks}&id=${id}`;
    } else if (remarks) {
      apiUrl += `?remarks=${remarks}`;
    } else if (id) {
      apiUrl += `?id=${id}`;
    }
  
    try {
      const response: AxiosResponse<RejectResponse> = await this.instance.post(
        apiUrl,
        {}, // No body needed
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error rejecting client request", error);
      throw error;
    }
  }
  
  
  async getAllDocuments(
    userId:number
  ): Promise<ClientIdResponse> {
    
    let apiUrl = "/integration/api/v1/get/all/documents";
   
    try {
      const response: AxiosResponse<ClientIdResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            userId:userId,
    
        },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async HelpTicketList(
   selectStatus:string | null,
   page:number,
   pageSize:number,
   searchValInput:string
  ): Promise<HelpTicketResponse> {
    
    let apiUrl = "/rsa/api/get/all/ticket";
    if (searchValInput) {
      apiUrl += `?mobile=${searchValInput}`;
    }
    try {
      const response: AxiosResponse<HelpTicketResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            page:page,
            pageSize:pageSize,
            status:selectStatus
    
        },
          
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async updateTicketStatus(ticketId: number, ticketStatus: string): Promise<any> {
    const apiUrl = "/rsa/api/update/ticket/status";
  
    try {
      const response: AxiosResponse<any> = await this.instance.post(
        apiUrl,
        {
          ticketId,
          ticketStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
  
      return response.data;
    } catch (error) {
      console.error("Error updating ticket status", error);
      throw error;
    }
  }
  
  async approveClientRequest({
    id,
    phoneNumber,
    clientUserId,
  }: {
    id?: string;
    phoneNumber: string;
    clientUserId: string;
  }): Promise<ApprovedResponse> {
    try {
      const response = await this.instance.post(
        "/integration/api/v1/approve/client/request",
        null,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            ...(id && { id }), // Only include if id is defined
            phoneNumber,
            clientUserId,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error approving client request", error);
      throw error;
    }
  }
  
  async MerchantListData(
   ): Promise<MerchantListResponse> {
     
     let apiUrl = "/clientDash/get/merchants";
     
     try {
       const response: AxiosResponse<MerchantListResponse> =
         await this.instance.get(apiUrl, {
           headers: {
             Authorization: `Bearer ${this.getToken()}`,
           },
          
           
         });
       return response.data;
     } catch (error) {
       console.error("Error fetching user past tickets", error);
       throw error;
     }
   }
   async KycTicketList(
    selectStatus:string | null,
    page:number,
    pageSize:number,
    searchValInput:string
   ): Promise<KycTicketResponse> {
     
     let apiUrl = "/kyc/api/v1/get/all/kyc/request";
     if (searchValInput) {
       apiUrl += `?mobile=${searchValInput}`;
     }
     try {
       const response: AxiosResponse<KycTicketResponse> =
         await this.instance.get(apiUrl, {
           headers: {
             Authorization: `Bearer ${this.getToken()}`,
           },
           params: {
             page:page,
             pageSize:pageSize,
             status:selectStatus
     
         },
           
         });
       return response.data;
     } catch (error) {
       console.error("Error fetching user past tickets", error);
       throw error;
     }
   }
   async getKycDocumentByUserId(
    userId:number,
    id:number
  ): Promise<KycDocumentResponse> {
    
    let apiUrl = "/integration/api/v1/get/kyc/all/document";
   
    try {
      const response: AxiosResponse<KycDocumentResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            userId:userId,
            supportTicketId:id
    
        },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }

  async rejectKycRequest(
    supportTicketId: number,
    remark: string,
    limitReset: string | null
  ): Promise<RejectKycResponse> {
    const apiUrl = "/kyc/api/kyc/reject";
  
    // Build the request body conditionally
    const body: any = {
      supportTicketId,
      remark,
    };
  
    if (limitReset !== null && limitReset !== "") {
      body.limitReset = limitReset;
    }
  
    try {
      const response: AxiosResponse<RejectKycResponse> = await this.instance.post(
        apiUrl,
        body,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error rejecting client request", error);
      throw error;
    }
  }
  
  async approvedKycRequest(
    supportTicketId: number,
    name: string | undefined,
    gender:string | undefined,
    dob:string | undefined,
    documentNumber:string | undefined,
    dlClassOfVehicle: string[] | undefined, // 👈 Updated here
    address :string | undefined,
  ): Promise<RejectKycResponse> {
    let apiUrl = "/kyc/api/kyc/approve";
  
  
    try {
      const response: AxiosResponse<RejectKycResponse> = await this.instance.post(
        apiUrl,
        {supportTicketId,name, gender, dob, documentNumber, dlClassOfVehicle , address}, // No body needed
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error rejecting client request", error);
      throw error;
    }
  }
  async approveBankStatement(
    supportTicketId: number,
    
  ): Promise<RejectKycResponse> {
    let apiUrl = "/kyc/api/kyc/approve";
  
  
    try {
      const response: AxiosResponse<RejectKycResponse> = await this.instance.post(
        apiUrl,
        {supportTicketId}, // No body needed
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error rejecting client request", error);
      throw error;
    }
  }
  async getLinkSend(
    id: number,
  ): Promise<RejectResponse> {
    let apiUrl = "/integration/api/v1/send/link";
  
    // Build query string with remarks first
    if ( id) {
      apiUrl += `?id=${id}`;
    } 
  
    try {
      const response: AxiosResponse<RejectResponse> = await this.instance.post(
        apiUrl,
        {}, // No body needed
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error rejecting client request", error);
      throw error;
    }
  }
  async TlList(
    selectStatus:string | null,
    page:number,
    pageSize:number
   ): Promise<TlDetailsResponse> {
     
     let apiUrl = "/kyc/api/get/tl/details";
     if (selectStatus) {
       apiUrl += `?search=${selectStatus}`;
     }
     try {
       const response: AxiosResponse<TlDetailsResponse> =
         await this.instance.get(apiUrl, {
           headers: {
             Authorization: `Bearer ${this.getToken()}`,
           },
           params: {
             page:page,
             pageSize:pageSize
     
         },
           
         });
       return response.data;
     } catch (error) {
       console.error("Error fetching user past tickets", error);
       throw error;
     }
   }
   async TlData(
   ): Promise<TlDataResponse> {
     
     let apiUrl = "/kyc/api/get/tl/count";
    
     try {
       const response: AxiosResponse<TlDataResponse> =
         await this.instance.get(apiUrl, {
           headers: {
             Authorization: `Bearer ${this.getToken()}`,
           },
          
           
         });
       return response.data;
     } catch (error) {
       console.error("Error fetching user past tickets", error);
       throw error;
     }
   }
   async DisableTl(
    tlId: number,
   
  ): Promise<RejectTlResponse> {
    let apiUrl = "/kyc/api/disable/tl";
  
  
    try {
      const response: AxiosResponse<RejectTlResponse> = await this.instance.post(
        apiUrl,
        {tlId}, // No body needed
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error rejecting client request", error);
      throw error;
    }
  }
}
